//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from '../../api/index';

export default {
  components: {
  },
  props: ['selectValue', 'selectLength', 'baseURL'],
  name: 'FrhomoloRegionSelect',
  data() {
    return {
      showSelect: false,
      region: '',
      optionProvince: [[{value: '', name: ''}]],
      optionCity: [[{value: '', name: ''}]],
      optionDistrict:[[{value: '', name: ''}]],
      regionValue: {
        province: [],
        city: [],
        district: []
      },
      showOption: {
        province: true,
        city: true,
        district: true
      },
      isInitValue: false,
      isClear: false,
      hasLeafCity: true,
      hasLeafDistrict: true
    }
  },
  methods: {
    chooseRegion() {
      this.showSelect = false;
      let result = '';
      if (this.showOption.province) {
        try {
          this.optionProvince[0].forEach(e => {
            if (e.value === this.regionValue.province[0]) {
              let name = e.name;
              if (e.name !== '市辖区' && e.name !== '县' && e.name !== '省直辖县级行政区划') {
                result += e.name;
                throw '';
              }
            }
          })
        } catch(e) {
        }
      }
      if (this.showOption.city) {
        try {
          this.optionCity[0].forEach(e => {
            if (e.value === this.regionValue.city[0]) {
              let name = e.name;
              if (e.name !== '市辖区' && e.name !== '县' && e.name !== '省直辖县级行政区划') {
                result = result.length > 0 ? result + '/' : '' ;
                result += e.name;
                throw '';
              }
            }
          })
        } catch(e) {
        }
      }
      if (this.showOption.district) {
        try {
          this.optionDistrict[0].forEach(e => {
            if (e.value === this.regionValue.district[0]) {
              let name = e.name;
              result = result.length > 0 ? result + '/' : '' ;
              result += e.name;
              throw '';
            }
          })
        } catch(e) {
        }
      }
      this.region = result;
    },
    initOption(arr) {
      let option = [];
      arr.forEach(e => {
        let obj = {};
        obj.value = e.code;
        obj.name = e.name;
        obj.leaf = e.leaf;
        option.push(obj);
      })
      return option;
    },
    ifNum(num) {
      let ifNUmber = num.split('');
      let isCode = true;
      ifNUmber.forEach(e => {
        let type = typeof +e;
        if(type !== 'number') {
          isCode = false;
        }
      })
      return isCode;
    },
    getProvinceList() {
      this.codesProvince = [];
      this.codesCity = [];
      let baseUrl = this.baseURL || '';
      this.optionProvince = [];
      api.getProvince('086', baseUrl).then(res => {
        this.optionProvince = [this.initOption(res.data)];
        this.optionCity = [];
        this.optionDistrict = [];
        if (this.isClear && this.showOption.province) {
          this.chooseProvince([this.optionProvince[0][0].value]);
          this.isClear = false;
        } else if (this.isClear) {
          this.chooseProvince([this.regionValue.province[0]]);
          this.isClear = false;
        }
      }).catch(err => {
        console.error(err);
      })
    },
    chooseProvince(code) {
      let adcode = code[0];
      if (this.isInitValue && this.regionValue.province[0].length > 0) {
        adcode = this.regionValue.province[0];
      }
      let baseUrl = this.baseURL || '';
      let leaf = this.hasLeaf(this.optionProvince[0], adcode);
      if (leaf) {
        this.hasLeafCity = false;
        this.hasLeafDistrict = false;
        this.regionValue.city = [''];
        this.regionValue.district = [''];
        if (this.isInitValue) {
          this.initRegionName();
        }
      } else if (adcode.length > 0) {
        this.hasLeafCity = true;
        this.hasLeafDistrict = true;
        api.getProvince(adcode, baseUrl).then(res => {
          this.optionCity = [this.initOption(res.data)];
          this.optionDistrict = [];
          if (this.regionValue.district[0].length === 0) {
            this.chooseCity([this.optionCity[0][0].value]);
          }
        }).catch(err => {
          console.error(err);
        })
      }
    },
    chooseCity(code) {
      let adcode = code[0];
      if (this.isInitValue && this.regionValue.city[0].length > 0) {
        adcode = this.regionValue.city[0];
      }
      let baseUrl = this.baseURL || '';
      let leaf = this.hasLeaf(this.optionCity[0], adcode);
      if (leaf) {
        this.hasLeafDistrict = false;
        this.regionValue.district = [''];
        if (this.isInitValue) {
          this.initRegionName();
        }
      } else if (adcode.length > 0) {
        this.hasLeafDistrict = true;
        api.getProvince(adcode, baseUrl).then(res => {
          this.optionDistrict = [this.initOption(res.data)];
          if (this.regionValue.district[0].length === 0) {
            this.regionValue.district[0] = this.optionDistrict[0][0].value;
          }
          if (this.isInitValue) {
            this.initRegionName();
            this.isInitValue = false;
          }
        }).catch(err => {
          console.error(err);
        })
      }
    },
    hasLeaf(option, code) {
      let leaf = false;
      option.forEach(e => {
        if (e.value === code) {
          leaf = e.leaf;
        }
      })
      return leaf;
    },
    clearSelect() {
      if (this.showOption.province && this.showOption.city && this.showOption.district ) {
        this.region = '';
        this.regionValue = {
          province: [''],
          city: [''],
          district: ['']
        }
        this.isClear = true;
        this.getProvinceList();
      } else {
        this.region = '';
      }
    },
    reset() {
      let tempValue = JSON.parse(JSON.stringify(this.regionValue));
      this.region = '';
      this.regionValue = {
        province: [''],
        city: [''],
        district: ['']
      }
      this.initRegion();
      this.chooseProvince(this.regionValue.province);
      this.initSelectLen();
    },
    initRegion() {
      if (this.selectValue) {
        this.isInitValue = true;
        if (this.selectValue.province && this.selectValue.province[0] && this.selectValue.province[0].length > 0) {
          let value = JSON.parse(JSON.stringify(this.selectValue))
          if (!value.city) {
            value.city = [''];
          }
          if (value.district && value.district[0] && value.district[0].length > 0) {
            value.city = [ this.selectValue.district[0].substring(0,4) + '00'];
          } else if (!value.district) {
            value.district = [''];
          }
          this.regionValue = JSON.parse(JSON.stringify(value));
        } else if (this.selectValue.city && this.selectValue.city[0] && this.selectValue.city[0].length > 0) {
          let province = this.selectValue.city[0].substring(0,2) + '0000';
          let value = {
            province: [province],
            city: [this.selectValue.city[0]],
            district: ['']
          }
          if (this.selectValue.district && this.selectValue.district[0] && this.selectValue.district[0].length > 0) {
            value.district = this.selectValue.district;
          }
          this.regionValue = JSON.parse(JSON.stringify(value));
        } else if (this.selectValue.district && this.selectValue.district[0] && this.selectValue.district[0].length > 0) {
          let province = this.selectValue.district[0].substring(0,2) + '0000';
          let city = this.selectValue.district[0].substring(0,4) + '0000';
          let value = {
            province: [province],
            city: [city],
            district: [this.selectValue.district[0]]
          }
          this.regionValue = JSON.parse(JSON.stringify(value));
        }
      }
    },
    initRegionName() {
      let result = '';
      if (this.showOption.province) {
        try {
          this.optionProvince[0].forEach(e => {
            if (e.value === this.regionValue.province[0]) {
              let name = e.name;
              if (e.name !== '市辖区' && e.name !== '县' && e.name !== '省直辖县级行政区划') {
                result += e.name;
                throw '';
              }
            }
          })
        } catch(e) {
        }
      }
      if (this.showOption.city) {
        try {
          this.optionCity[0].forEach(e => {
            if (e.value === this.regionValue.city[0]) {
              let name = e.name;
              if (e.name !== '市辖区' && e.name !== '县' && e.name !== '省直辖县级行政区划') {
                result = result.length > 0 ? result + '/' : '' ;
                result += e.name;
                throw '';
              }
            }
          })
        } catch(e) {
        }
      }
      if (this.showOption.district) {
        try {
          this.optionDistrict[0].forEach(e => {
            if (e.value === this.regionValue.district[0]) {
              let name = e.name;
              result = result.length > 0 ? result + '/' : '' ;
              result += e.name;
              throw '';
            }
          })
        } catch(e) {
        }
      }
      this.region = result;
      this.isInitValue = false;
    },
    getResult() {
      return {
        code: this.regionValue,
        name: this.region
      }
    },
    initSelectLen() {
      if (this.selectLength) {
        switch(this.selectLength.start) {
          case 0:
            this.showOption.province = true;
            this.showOption.city = (!this.selectLength.length || this.selectLength.length > 1) ? true: false;
            this.showOption.district = (!this.selectLength.length || this.selectLength.length > 2) ? true: false;
            break;
          case 1:
            this.showOption.province = false;
            this.showOption.city = true;
            this.showOption.district = (!this.selectLength.length || this.selectLength.length > 1) ? true: false;
            break;
          case 2:
            this.showOption = {
              province: false,
              city: false,
              district: true
            }
            break;
          default:
            this.showOption = {
              province: true,
              city: true,
              district: true
            }
            break;
        }
      }
    }
  },
  watch: {
    selectLength() {
      this.initSelectLen();
    },
    selectValue() {
      this.initRegion();
    }
  },
  computed: {},
  created() {
    this.initSelectLen();
    this.getProvinceList();
    this.initRegion();
  },
  mounted() {
  }
};
